import GLightbox from 'glightbox'; // @link https://github.com/biati-digital/glightbox

// eslint-disable-next-line no-unused-vars
const lightbox = GLightbox({
  zoomable: false
});
